import './style.css'
import { md2html } from "./converter"
import { MdFormat } from "./types"

const PrettyMarkdownBox = ({value, whitelist=null, style={}}:{ value:string, whitelist?:MdFormat[]|null, style?:object}) => {
  const content = md2html(value, null, whitelist, 'per-paragraph')
  return <div className="pretty-markdown-input" style={{border:"none", ...style}} dangerouslySetInnerHTML={{__html: content.replace(/\n/g, '')}} />
}


export default PrettyMarkdownBox